const local = {
  cognito: {
    REGION: 'us-west-2',
    USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
    APP_CLIENT_ID: process.env.REACT_APP_APP_CLIENT_ID,
    OAUTH: {
      domain: 'ecomanalytics1.auth.us-west-2.amazoncognito.com',
      redirectSignIn: 'http://localhost:3000/auth/oauth',
      redirectSignOut: 'http://localhost:3000/logout',
      responseType: 'code',
    },
  },
  api: {
    SERVER_URL: process.env.REACT_APP_SERVER_URL,
  },
  stripe: {
    PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  },
  posthog: {
    API_KEY: process.env.REACT_APP_POSTHOG_API_KEY,
  },
  spApi: {
    APPLICATION_ID: process.env.REACT_APP_SP_API_APPLICATION_ID,
    REDIRECT_URI: process.env.REACT_APP_SELLER_CENTRAL_REDIRECT_URL,
    BUTTON_VISIBLE_TO: process.env.REACT_APP_DEMO_USER_ID,
    IS_DRAFT: process.env.REACT_APP_SP_API_IS_DRAFT === 'true',
  },
  productIds: {
    basic: 'prod_JXdOnKZyLjnOs8',
    pro: 'prod_JXdPNU93ruyXCr',
    betaUser: 'prod_Joq3l4InSFzNz0',
    specialBetaPlan: 'prod_K0pf1tuV7P3Cfm',
    business: 'prod_L6aYRHpUHA1L1X',
    enterprise: 'prod_LqjGEr4UeXezYa',
  },
  recaptcha: {
    SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY_V2_INVISIBLE,
    ENABLE_GOOGLE_RECAPTCHA: false,
  },
};

const staging = {
  cognito: {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_2dfnWCVV4',
    APP_CLIENT_ID: '2togoqs34oig95bg98s73ob93i',
    OAUTH: {
      domain: 'ecomanalytics1.auth.us-west-2.amazoncognito.com',
      redirectSignIn: 'https://app.data-staging.com/auth/oauth',
      redirectSignOut: 'https://app.data-staging.com/logout',
      responseType: 'code',
    },
  },
  api: {
    SERVER_URL: 'https://api.data-staging.com',
  },
  stripe: {
    PUBLIC_KEY: 'pk_test_51RQMvIH1mj1tDcHSI3tdNjJ0ZCZYjqgpPqYrWNpV8yQyb42Y7nmVBHD8AQWdIOqMOhxkWaMupL9DOSjoFafdDAAJ00aTMVhHk4',
  },
  posthog: {
    API_KEY: 'phc_cVdkGfdHdhvyg4JhrU0FtwTnT6Df49nu9L8o4NKPxqw',
  },
  spApi: {
    APPLICATION_ID: 'amzn1.sp.solution.f77546c5-a6e7-4dc8-a18c-83a50a14751d',
    REDIRECT_URI: 'https://api.data-staging.com/sp-api/auth',
    BUTTON_VISIBLE_TO: 'b348e714-896f-4fd0-a8f4-62967d24239d',
    IS_DRAFT: true,
  },
  productIds: {
    basic: 'prod_JXdOnKZyLjnOs8',
    pro: 'prod_JXdPNU93ruyXCr',
    betaUser: 'prod_Joq3l4InSFzNz0',
    specialBetaPlan: 'prod_K0pf1tuV7P3Cfm',
    business: 'prod_L6aYRHpUHA1L1X',
    enterprise: 'prod_LqjGEr4UeXezYa',
  },
  recaptcha: {
    SITE_KEY: '6LcTqjcrAAAAADo4nKpYUjmEF06hBg44Fsjq45_6',
    ENABLE_GOOGLE_RECAPTCHA: false,
  },
};

const prod = {
  cognito: {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_0CKqzWHDX',
    APP_CLIENT_ID: '5dcti49pggi19uqs3df8iae3o1',
    OAUTH: {
      domain: 'ecomanalytics1.auth.us-west-2.amazoncognito.com',
      redirectSignIn: 'https://app.datarova.com/auth/oauth',
      redirectSignOut: 'https://app.datarova.com/logout',
      responseType: 'code',
    },
  },
  api: {
    SERVER_URL: 'https://api.datarova.com',
  },
  stripe: {
    PUBLIC_KEY: 'pk_live_ae0CSedPBE5e92IjzUJwAeE2',
  },
  posthog: {
    API_KEY: 'phc_uVYaX4VvEwBuISEZG42popj6Az3vVlsAmjYMbUuQxoa',
  },
  spApi: {
    APPLICATION_ID: 'amzn1.sp.solution.33478e47-0c55-4b5b-9f92-e1b4933c4c19',
    REDIRECT_URI: 'https://api.datarova.com/sp-api/auth',
    BUTTON_VISIBLE_TO: 'b348e714-896f-4fd0-a8f4-62967d24239d',
    IS_DRAFT: false,
  },
  productIds: {
    basic: 'prod_JXdGUxZ898L6lq',
    pro: 'prod_JXdHiobD2AZTtH',
    betaUser: 'prod_IL2oey7sgs3yLc',
    specialBetaPlan: 'prod_K1Zebwfx8VugFV',
    business: 'prod_L6IgB6Fs6bGBeO',
    enterprise: 'prod_LqjFmaLKMN44Rp',
  },
  recaptcha: {
    SITE_KEY: '6LcTqjcrAAAAADo4nKpYUjmEF06hBg44Fsjq45_6',
    ENABLE_GOOGLE_RECAPTCHA: true,
  },
};

var config;

switch (process.env.REACT_APP_STAGE) {
  case 'prod':
    config = prod;
    break;
  case 'staging':
    config = staging;
    break;
  case 'local':
    config = local;
    break;
  default:
    throw new Error('Environment not set');
}

export default {
  intercom: {
    APP_ID: 'yul8somt',
  },
  ...config,
};
